module.exports = __webpack_public_path__ + "images/emoji/christmas_tree.5aacbd6d50965690b409.png";